/** Domain service module: events.js */
import { request } from '../http/request'
import { API_BASE_URL } from './config'

class EventService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/event/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  myEvents(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/event/myEvents?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/event/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  delete(id) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/event/delete/${id}`, 'delete');
        resolve(_result?.data || null)
      } catch (error) {
        reject(error);
      }
    });
  }
}

class EventInvitationService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventInvitation/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventInvitation/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  listUnauthorized(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventInvitation/listUnauthorized?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class EventStaffService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventStaff/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
  updateOrCreate(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventStaff/updateOrCreate`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class EventFileService {
  list(data, page) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventFile/list?page=${page || 1}`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

class EventAuthorizationService {
  authorize(data) {
    return new Promise(async (resolve, reject) => {
      try {
        let _result = await request(`${API_BASE_URL}/eventAuthorization/authorize`, 'post', data)
        resolve(_result?.data?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }

  getClientIP() {
    return new Promise(async (resolve, reject) => {
      try {
        // get me
        let _result = await request(`${API_BASE_URL}/clientIp`, 'get')
        resolve(_result?.data || null)
      } catch (error) {
        reject(error)
      }
    });
  }
}

export const event = new EventService()
export const eventInvitation = new EventInvitationService()
export const eventStaff = new EventStaffService()
export const eventFile = new EventFileService()
export const eventAuthorization = new EventAuthorizationService()
